import axios from '@/utils/axios';

export const warehousesList = async () => {
 const response = await axios.get(`/inventory/warehouses/dropdown`);
 return response;
}

export const wById = async (warehouse_id) => {
 const response = await axios.get(`/inventory/warehouses/${warehouse_id}`);
 return response;   
}